import { useContext, useState } from "react";
import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircle from "@mui/icons-material/CheckCircle";
import { CheckCircleOutline } from "@mui/icons-material";
import CheckPermission from "../../../../helpers/Administradores/Permissions";
const MenuListNoEvaluar = (props: any, evaluar: any) => {
  const [seeDetails, setSeeDetails] = useState<any>(null);
  const open = Boolean(seeDetails);
  console.log("props", props);
  const seeInformation = () => {
    console.log("Ver Información");
  };
  const terminarCurso = () => {
    console.log("Terminar curso");
  };
  return (
    <>
      <Tooltip title="Opciones" placement="right">
        <Box className="IconButtonPoints" mr={2}>
          <IconButton onClick={(e) => setSeeDetails(e.currentTarget)}>
            <MoreVertIcon style={{ color: "#fabb00" }} />
          </IconButton>
        </Box>
      </Tooltip>
      <Menu
        className="MoreVerIcon"
        anchorEl={seeDetails}
        open={open}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={() => setSeeDetails(null)}
      >
        {CheckPermission("FormacionDesarrollo.Cursos.Ver") && (
          <MenuItem
            button
            onClick={seeInformation}
            style={{ justifyContent: "space-between" }}
          >
            <div className="contenedorTextoMenuCourse">
              <span className="textoMenuEditarCourse">Ver</span>
            </div>
            <div>
              <VisibilityIcon className="iconoMenuViewCourse" />
            </div>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
export default MenuListNoEvaluar;
